<template>


	<div v-if="!isUploading">
	<!--v-container grid-list-md text-xs-center-->
		 
 		<v-card v-for="(f, i) in files" style="margin-bottom:2em;" :key="i">
 			 <v-img v-if="f.uploaded === true"
 			 	:src="path + '/' + route.name + '/' +  parseFile(f.name)"
 			 	aspect-ratio="1"
 			 ></v-img>

 			 <v-text-field v-if="newTask.answers && newTask.type !== 21"
 			 	@keyup="setAnswerContent($event, f.name)"
 			 	:label="translater.__('Answer', 'tasks')"
 			 	:value="newTask.answers[f.name]"
 			 >
 			 	
 			 </v-text-field>


 		</v-card>
 	</div>
		 	
	<!--/v-container-->
</template>

<script>

	import {parseFileName} from '../../../tools';
	
	export default {
		name: 'ImageAnswers',
		props: ['validateMethod'],
		data()
		{
			return{}
		},

		created(){
			/*window.vm.$on('fileUploaded', () => {
				this.$forceUpdate();
			})*/
		},

		methods: {
			setAnswerContent(e, name)
			{
				this.$store.dispatch('checkpoints/setNewTaskAnswer', {value: e.target.value, name: name})

				this.$store.dispatch(this.validateMethod)
				.then((valid) => {
					this.$store.commit('checkpointsValidator/setValid', valid)
				})
			},

			parseFile(fn)
			{
				return parseFileName(fn);
			}
		},

		computed: {
			files: {
				get()
				{
					return this.$store.getters['files/filesToUpload'];
				}
			},

			isUploading:
			{
				get()
				{
					return this.$store.getters['files/isUploading'];
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPath'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			newTask: {
				get()
				{
					return this.$store.getters['checkpoints/newTask']
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater']
				}
			}

			

		}
	}
</script>

